import { render, staticRenderFns } from "./FormNewProject.vue?vue&type=template&id=fc2f172a"
import script from "./FormNewProject.vue?vue&type=script&lang=js"
export * from "./FormNewProject.vue?vue&type=script&lang=js"
import style0 from "./FormNewProject.vue?vue&type=style&index=0&id=fc2f172a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports